import React from 'react';
import { useTranslation } from 'react-i18next';
import './styles.scss';

const clientConfig = {
  socialLinks: [
    {
      href: 'https://www.facebook.com/Simplevenezuela/',
      title: 'facebook',
      icon: 'bi-facebook',
    },
    {
      href: 'https://x.com/Simple_vzla',
      title: 'twitter-x',
      icon: 'bi-twitter-x',
    },
    {
      href: 'https://www.youtube.com/@simple_vzla',
      title: 'youtube',
      icon: 'bi-youtube',
    },
    {
      href: 'https://www.instagram.com/simple_vzla/',
      title: 'instagram',
      icon: 'bi-instagram',
    },
  ],
  stores: [
    {
      href: 'https://apps.apple.com/us/app/simpleplus/id6446922417',
      title: 'iOS',
      image: '/images/ios_store.png',
    },
    {
      href: 'https://play.google.com/store/apps/details?id=ve.simpleplus.app&pli=1',
      title: 'Android',
      image: '/images/android_store.png',
    },
  ],
};

function SimpleTvFooter() {
  const { t } = useTranslation();

  const legalLinks = [
    {
      href: 'https://www.simple.com.ve/simpleplus/terminos-y-condiciones/',
      label: t('Terms of service'),
    },
    {
      href: 'https://www.simple.com.ve/simpleplus/politica-de-privacidad/',
      label: t('Privacy policy'),
    },
    { href: 'https://simpletv.helpsite.cloud/home', label: t('Help') },
  ];

  return (
    <footer className="simpletv-footer">
      <div className="footer-container">
        <div className="footer-links">
          {legalLinks.map(({ href, label }) => (
            <a
              key={href}
              className="footer-link"
              href={href}
              target="_blank"
              rel="noreferrer"
            >
              {label}
            </a>
          ))}
        </div>

        <div className="footer-right">
          <div className="footer-media">
            <div className="social-icons">
              {clientConfig.socialLinks.map(({ href, icon, title }) => (
                <a
                  key={title}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  title={title}
                  className="social-icon"
                >
                  <i className={`bi ${icon}`} />
                </a>
              ))}
            </div>
            <div className="store-icons">
              {clientConfig.stores.map(({ href, image, title }) => (
                <a
                  key={title}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  title={title}
                >
                  <img src={image} alt={title} width={120} height={40} />
                </a>
              ))}
            </div>
          </div>

          <div className="footer-brand">
            ©{t('Footer Description')}. {t('All rights reserved.')}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default SimpleTvFooter;
